import { render, staticRenderFns } from "./TokoSetup.vue?vue&type=template&id=239144e4"
import script from "./TokoSetup.vue?vue&type=script&lang=js"
export * from "./TokoSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports